import { useEffect, useRef, useState } from "react";
import { Card, Table, Form, Button, Row, Col, Dropdown } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import EditDealModal from "../../../components/modals/deals/List/EditDealModal";
import DeleteDealModal from "../../../components/modals/deals/DeleteDealModal";
import DealsPage from "../../../components/crm/deals/DealsHeader";
// import EditDealModal from "../../modals/deals/EditDealModal";
// import DeleteDealModal from "../../modals/deals/DeleteDealModal";
import { FiCalendar, FiChevronDown } from "react-icons/fi";
import DealsHeader from "../../../components/crm/deals/DealsHeader";
const initialDeals = [
  {
    id: 1,
    name: "Collins",
    stage: "Quality To Buy",
    value: "$4,50,000",
    tag: "Promotion",
    date: "14 Jan 2024",
    owner: "Hendry",
    probability: "70%",
    status: "Open",
  },
  {
    id: 2,
    name: "Konopelski",
    stage: "Proposal Made",
    value: "$3,15,000",
    tag: "Rated",
    date: "21 Jan 2024",
    owner: "Guilory",
    probability: "85%",
    status: "Won",
  },
  {
    id: 3,
    name: "Adams",
    stage: "Contact Made",
    value: "$8,40,000",
    tag: "Promotion",
    date: "20 Feb 2024",
    owner: "Jami",
    probability: "60%",
    status: "Open",
  },
  {
    id: 4,
    name: "Schumm",
    stage: "Quality To Buy",
    value: "$6,10,000",
    tag: "Collab",
    date: "15 Mar 2024",
    owner: "Theresa",
    probability: "75%",
    status: "Won",
  },
    {
    id: 5,
    name: "Collins",
    stage: "Quality To Buy",
    value: "$4,50,000",
    tag: "Promotion",
    date: "14 Jan 2024",
    owner: "Hendry",
    probability: "70%",
    status: "Open",
  },
  {
    id: 6,
    name: "Konopelski",
    stage: "Proposal Made",
    value: "$3,15,000",
    tag: "Rated",
    date: "21 Jan 2024",
    owner: "Guilory",
    probability: "85%",
    status: "Won",
  },
];

const DealsList = () => {
  const [deals, setDeals] = useState(initialDeals);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);
  const [show, setShow] = useState(false);

  const [editData, setEditData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);

  const filteredDeals = deals.filter((d) =>
    d.name.toLowerCase().includes(search.toLowerCase()),
  );

  const handleDelete = () => {
    setDeals(deals.filter((d) => d.id !== deleteData.id));
    setDeleteData(null);
  };

  const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Last 7 Days");
  const ref = useRef();

  // close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (!ref.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <div
      style={{ padding: "15px", background: "#f8f9fa" }}
      className=" "
    >
      {/* <DealsPage  /> */}
      <DealsHeader onAdd={() => setShow(true)}  title="Deals List" />

      <Card className="p-3 shadow-sm">
        {/* HEADER */}
        <Row className="align-items-center deal-header mb-3 g-2">
          {/* LEFT TITLE */}
          <Col lg={4} md={12}>
            <h5 className="mb-0 fw-semibold">Deal List</h5>
          </Col>

          {/* RIGHT FILTERS */}
          <Col lg={8} md={12}>
            <div className="d-flex flex-wrap justify-content-lg-end gap-2">
              {/* DATE RANGE */}
              <div className="date-wrapper" ref={ref}>
                {/* Input */}
                <div className="date-box" onClick={() => setOpen(!open)}>
                  <FiCalendar />
                  <input value="03/30/2026 - 04/05/2026" readOnly />
                </div>

                {/* Dropdown */}
                {open && (
                  <div className="date-dropdown">
                    {options.map((item, index) => (
                      <div
                        key={index}
                        className={`date-item ${
                          selected === item ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelected(item);
                          setOpen(false);
                        }}
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* STAGE */}
              <Dropdown>
                <Dropdown.Toggle className="date-box text-dark">
                  Stage
                  {/* <FiChevronDown cl size={14} /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown">
                  <Dropdown.Item>Quality To Buy</Dropdown.Item>
                  <Dropdown.Item>Proposal Made</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* STATUS */}
              <Dropdown>
                <Dropdown.Toggle className="date-box text-dark">
                  Select Status
                  {/* <FiChevronDown size={14} /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown">
                  <Dropdown.Item>Open</Dropdown.Item>
                  <Dropdown.Item>Won</Dropdown.Item>
                  <Dropdown.Item>Lost</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* SORT */}
              <Dropdown>
                <Dropdown.Toggle className="date-box text-dark">
                  Sort By : Last 7 Days
                  {/* <FiChevronDown size={14} /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown">
                  <Dropdown.Item>Today</Dropdown.Item>
                  <Dropdown.Item>Yesterday</Dropdown.Item>
                  <Dropdown.Item active className="active-item">
                    Last 7 Days
                  </Dropdown.Item>
                  <Dropdown.Item>Last 30 Days</Dropdown.Item>
                  <Dropdown.Item>This Year</Dropdown.Item>
                  <Dropdown.Item>Next Year</Dropdown.Item>
                  <Dropdown.Item>Custom Range</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
        </Row>

        {/* SECOND ROW (ROW COUNT + SEARCH) */}
        <Row className="align-items-center mb-3 g-2">
          <Col md={6} className="d-flex align-items-center gap-2">
            <span className="text-muted">Row Per Page</span>

            <Form.Select
              value={rows}
              onChange={(e) => setRows(e.target.value)}
              className="row-select"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </Form.Select>

            <span className="text-muted">Entries</span>
          </Col>

          <Col md={6} className="text-md-end">
            <Form.Control
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover className="align-middle">
            <thead className="table-light">
              <tr>
                <th>Deal Name</th>
                <th>Stage</th>
                <th>Deal Value</th>
                <th>Tags</th>
                <th>Expected Date</th>
                <th>Owner</th>
                <th>Probability</th>
                <th>Status</th>
                <th className="text-end">Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredDeals.slice(0, rows).map((deal) => (
                <tr key={deal.id}>
                  <td>{deal.name}</td>
                  <td>{deal.stage}</td>
                  <td>{deal.value}</td>

                  <td>
                    <span className="badge bg-light text-dark">{deal.tag}</span>
                  </td>

                  <td>{deal.date}</td>
                  <td>{deal.owner}</td>
                  <td>{deal.probability}</td>

                  <td>
                    <span
                      className={`badge ${
                        deal.status === "Won"
                          ? "bg-success"
                          : deal.status === "Lost"
                            ? "bg-danger"
                            : "bg-primary"
                      }`}
                    >
                      {deal.status}
                    </span>
                  </td>

                  <td className="text-end">
                    <Button
                      variant="link"
                      className="p-1 text-dark"
                      onClick={() => setEditData(deal)}
                    >
                      <FiEdit2 />
                    </Button>

                    <Button
                      variant="link"
                      className="p-1 text-dark"
                      onClick={() => setDeleteData(deal)}
                    >
                      <FiTrash2 />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* FOOTER */}
        <div className="deal-footer d-flex justify-content-between align-items-center">
          {/* LEFT TEXT */}
          <small className="text-muted">
            Showing {filteredDeals.length > 0 ? 1 : 0} to{" "}
            {Math.min(rows, filteredDeals.length)} of {filteredDeals.length}{" "}
            entries
          </small>

          {/* RIGHT PAGINATION */}
          <div className="d-flex align-items-center gap-2">
            {/* LEFT ARROW */}
            <span className="page-arrow">‹</span>

            {/* ACTIVE PAGE */}
            <span className="page-number active">1</span>

            {/* RIGHT ARROW */}
            <span className="page-arrow">›</span>
          </div>
        </div>
      </Card>

      {/* MODALS */}
      <EditDealModal
        show={!!editData}
        handleClose={() => setEditData(null)}
        data={editData}
      />

      <DeleteDealModal
        show={!!deleteData}
        handleClose={() => setDeleteData(null)}
        onDelete={handleDelete}
      />
      <style>
        {`
          /* FILTER BOX (top buttons) */
.filter-box {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 6px;
  font-size: 14px;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* DROPDOWN MENU */
.custom-dropdown {
  border-radius: 8px;
  padding: 6px 0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border: none;
}

/* DROPDOWN ITEMS */
.custom-dropdown .dropdown-item {
  font-size: 14px;
  padding: 8px 14px;
}

/* ACTIVE ITEM (orange highlight like image) */
.active-item {
  background-color: #ff6a00 !important;
  color: #fff !important;
}

/* ROW SELECT */
.row-select {
  width: 70px;
  font-size: 14px;
  padding: 4px 8px;
}

/* SEARCH INPUT */
.search-input {
  max-width: 250px;
  display: inline-block;
  font-size: 14px;
}


/* Wrapper */
.date-wrapper {
  position: relative;
  width: 220px;
}

/* Input box */
.date-box {
  display: flex;
  align-items: center;
  gap: 10px;
  display: flex;
  align-items: center;

  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  cursor: pointer;
}

.date-box svg {
  font-size: 18px;
  color: #374151;
}

.date-box input {
  border: none;
  outline: none;
  font-size: 14px;
  width: 100%;
  color: #111827;
  cursor: pointer;
}

/* Dropdown */
.date-dropdown {
  position: absolute;
  top: 110%;
  left: 0;

  width: 100%;
  background: #fff;

  border: 1px solid #e5e7eb;
  border-radius: 8px;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  z-index: 1000;
}

.date-box:hover,
.date-box:focus,
.date-box:active,
.date-box.show {
  background-color: #fff !important;
  color: #111827 !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
/* Arrow top */
.date-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;

  width: 12px;
  height: 12px;
  background: white;

  border-left: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;

  transform: rotate(45deg);
}

/* Items */
.date-item {
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background 0.2s ease;
}

/* Hover */
.date-item:hover {
  background: #f3f4f6;
}

/* Active (ORANGE) */
.date-item.active {
  background: #f97316;
  color: #fff;
}

/* Mobile */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}

/* HEADER BORDER (top + bottom like image) */
.deal-header {

  border-bottom: 1px solid #e5e7eb;
  padding-top: 12px;
  padding-bottom: 10px;
  background: #fff;
}

/* TABLE HEADER LINE (important) */
.table thead tr {
  border-bottom: 1px solid #e5e7eb;
}

/* EACH ROW SEPARATOR */
.table tbody tr {
  border-bottom: 1px solid #f1f1f1;
}

/* REMOVE EXTRA BOOTSTRAP HEAVY BORDER */
.table > :not(caption) > * > * {
  border-bottom: none;
}

/* FOOTER BORDER */
.deal-footer {
  border-top: 1px solid #e5e7eb;
  padding-top: 10px;
  margin-top: 10px;
}


  /* FOOTER CONTAINER */
.deal-footer {
  border-top: 1px solid #e5e7eb;
  padding: 10px 0;
}

/* TEXT */
.deal-footer small {
  font-size: 13px;
  color: #6b7280;
}

/* PAGINATION WRAPPER */
.page-arrow,
.page-number {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
}

/* ARROWS */
.page-arrow {
  color: #9ca3af;
}

/* ACTIVE PAGE (ORANGE CIRCLE) */
.page-number.active {
  background-color: #ff6a00;
  color: #fff;
  font-weight: 500;
}

/* HOVER EFFECT */
.page-arrow:hover {
  background: #f3f4f6;
}
/* MOBILE FIX */
@media (max-width: 768px) {
  .search-input {
    width: 100%;
    max-width: 100%;
    margin-top: 10px;
  }
}`}
      </style>
    </div>
  );
};

export default DealsList;
